import React, { useState } from "react";
import { useGlobalContext } from "../../hooks/context";
import { totalAmount } from "../../utils/amount";
import useTestPayment from "../../hooks/useTestPayment";
import CustomModal from "../modal/CustomModal";
import PaymentReceipt from "../receipt/PaymentReceipt";
import PaymentClose from "./PaymentClose";
import { useNavigate } from "react-router-dom";
import ItemsReceipt from "../receipt/ItemsReceipt";

const PaymentButton = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { message, onPayment, onClose, paymentId } = useTestPayment();
  const { selectedItems } = useGlobalContext();
  const amount = totalAmount(selectedItems);

  const hasReceipt = selectedItems.some((item) => item.isReceipt);

  // nvaigate to home
  const navigateToHome = () => {
    navigate("/");
  };

  // payment function
  const paymentHandler = async () => {
    setOpen(true);
    onPayment();
  };

  // close modal
  const closeHandler = () => {
    onClose();
    setOpen(false);
    navigateToHome();
  };

  let content = "";
  switch (message.toLowerCase()) {
    case "success":
      content = !hasReceipt ? (
        <PaymentReceipt
          message={message}
          paymentId={paymentId}
          onClose={closeHandler}
        />
      ) : (
        <ItemsReceipt
          message={message}
          paymentId={paymentId}
          onClose={closeHandler}
        />
      );
      break;
    case "cancelled":
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">
            Status: {message}
          </p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
      break;
    case "please follow the instructions on the terminal.":
      content = (
        <p className="text-3xl font-semibold tracking-wider">{message}</p>
      );
      break;

    default:
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">{message}</p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
      break;
  }

  return (
    <>
      <button
        type="button"
        className="confirm-button"
        disabled={amount <= 0}
        onClick={paymentHandler}
      >
        Pay Now
      </button>
      <CustomModal closeIcon={false} open={open} onClose={closeHandler}>
        <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
          {content}
        </div>
      </CustomModal>
    </>
  );
};

export default PaymentButton;
